import { getDeviceId, getPortalId, getSessionId, getUtk } from 'usage-tracker-core/common/defaultTrackers';
import { SESSION_REPLAY_ID_PROPERTY } from 'usage-tracker-core/constants';
// Used to provide App Info to the Session Replay Tracking/Config Endpoint
const getAppInfo = () => {
  var _window$hubspot$bende, _window$hubspot, _window$hubspot$bende2, _window$hubspot2, _getPortalId;
  return {
    // retrieves the deployable name if available from window context
    // @ts-ignore this is a global variable and we don't have control over it
    name: (_window$hubspot$bende = (_window$hubspot = window.hubspot) === null || _window$hubspot === void 0 || (_window$hubspot = _window$hubspot.bender) === null || _window$hubspot === void 0 ? void 0 : _window$hubspot.currentProject) !== null && _window$hubspot$bende !== void 0 ? _window$hubspot$bende : 'unknown',
    // retrieves the deployable version if available from window context
    // @ts-ignore this is a global variable and we don't have control over it
    version: (_window$hubspot$bende2 = (_window$hubspot2 = window.hubspot) === null || _window$hubspot2 === void 0 || (_window$hubspot2 = _window$hubspot2.bender) === null || _window$hubspot2 === void 0 ? void 0 : _window$hubspot2.currentProjectVersion) !== null && _window$hubspot$bende2 !== void 0 ? _window$hubspot$bende2 : 'unknown',
    // retrieves the portal id if available from the running context
    portalId: (_getPortalId = getPortalId()) !== null && _getPortalId !== void 0 ? _getPortalId : 'unknown'
  };
};

// Provides the `Authorization` Header (workaround) for providing relevant
// App Info and Portal ID to the Session Replay Tracking/Config Endpoint
/** @todo: this should be superseeded by Apmlitude's SDK `transportProvider` */
export const getAuthorizationKey = () => `${getAppInfo().name}:::${getAppInfo().version}:::${getAppInfo().portalId}`;

// Tells us if the tracker is in standalone mode or not
export const isTrackerInStandaloneMode = target => Boolean(target.getConfig().standalone);

// Since Amplitude Session Replay SDK only has a `getSessionId` method, we want to get the current
// registered Device Id and Session Id from Amplitude, so we can compare if they match the current Tracker
// and if not replace them with the current Tracker's Device Id and Session Id
export const extractAmplitudeIdentifiers = amplitudeProperties => {
  var _sessionReplayId$spli;
  const sessionReplayId = amplitudeProperties[SESSION_REPLAY_ID_PROPERTY];

  // If the property is not available, we return undefined for both Device Id and Session Id
  const [deviceId, sessionId] = (_sessionReplayId$spli = sessionReplayId === null || sessionReplayId === void 0 ? void 0 : sessionReplayId.split('/')) !== null && _sessionReplayId$spli !== void 0 ? _sessionReplayId$spli : [undefined, 0];
  return [deviceId, Number(sessionId)];
};

// Reads the latest deviceId and sessionId for the Session Replay ID, without
// advancing the tracker's identity/session counters.
export const getTrackerMetaProperties = (target, deviceIdFromTrackCall) => {
  var _ref, _getUtk;
  const {
    deviceId: deviceIdFromConfig
  } = target.getConfig().properties;
  const deviceId = (_ref = deviceIdFromTrackCall !== null && deviceIdFromTrackCall !== void 0 ? deviceIdFromTrackCall : deviceIdFromConfig) !== null && _ref !== void 0 ? _ref : getDeviceId();
  const sessionId = getSessionId();
  return [(_getUtk = getUtk()) !== null && _getUtk !== void 0 ? _getUtk : deviceId, sessionId];
};